import axios, { AxiosRequestConfig } from "axios";
import { EventSource } from "eventsource";
import { getSession } from "~/lib/session";

export const GET_CURRENT_USER_PATH = "/api/v1/users/me";

export const getRequest = async (
  path: string,
  options: AxiosRequestConfig = {}
) => {
  const response = await axios.get(
    `${import.meta.env.VITE_BACKEND_URL}${path}`,
    {
      ...options,
      headers: {
        ...options.headers,
      },
    }
  );
  return response.data;
};

const getAuthHeader = () => {
  const session = getSession();
  return `${session.tokenType} ${session.accessToken}`;
};

export const getRequestWithAuth = async (
  path: string,
  options: AxiosRequestConfig = {}
) => {
  const session = getSession();
  const response = await axios.get(
    `${import.meta.env.VITE_BACKEND_URL}${path}`,
    {
      ...options,
      headers: {
        ...options.headers,
        Authorization: getAuthHeader(),
      },
    }
  );
  return response.data;
};

export const getBlobRequestWithAuth = async (
  path: string,
  options: AxiosRequestConfig = {}
) => {
  const session = getSession();
  const response = await axios.get(
    `${import.meta.env.VITE_BACKEND_URL}${path}`,
    {
      ...options,
      headers: {
        ...options.headers,
        Authorization: getAuthHeader(),
      },
      responseType: "blob",
    }
  );
  return response;
};

export const getCurrentUser = async () => {
  const user = await getRequestWithAuth("/api/v1/users/me");
  return user;
};

export const postRequest = async (path: string, data: any, options: AxiosRequestConfig = {}) => {
  const response = await axios.post(`${import.meta.env.VITE_BACKEND_URL}${path}`, data, {
      ...options,
      headers: {
          ...options.headers,
      }
  });
  return response.data;
}

export const postRequestWithAuth = async (
  path: string,
  data: any,
  options: AxiosRequestConfig = {}
) => {
  const session = getSession();
  const response = await axios.post(
    `${import.meta.env.VITE_BACKEND_URL}${path}`,
    data,
    {
      ...options,
      headers: {
        ...options.headers,
        Authorization: getAuthHeader(),
      },
    }
  );
  return response.data;
};

export const getEventStream = (
  path: string,
  options: AxiosRequestConfig = {}
) => {
  const session = getSession();
  const eventSource = new EventSource(
    `${import.meta.env.VITE_BACKEND_URL}${path}`,
    {
      fetch: (input, init) =>
        fetch(input, {
          ...init,
          headers: {
            ...init?.headers,
            Authorization: getAuthHeader(),
          },
        }),
    }
  );
  return eventSource;
};
